const Constants = [
    'DEFAULT',
    'SUCCESS',
    'INFO',
    'ERROR',
];

const NotificationConstants = Constants.reduce((accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
}, {});

export default NotificationConstants;
